/* eslint-disable */
import BaseService from "../../BaseService";

const { http, axios, buildHeaders, buildEndpoint } = BaseService();

// API
//////////////////////////////////////////////////////////////////

export function XuatBaoCao(postdata) {
  const data = { ...postdata };
  return http({
    url: "XuatBaoCao/ExportExcel",
    method: "post",
    data,
  });
};

export function XuatBaoCaoWord(postdata) {
  const data = { ...postdata };
  return http({
    url: "XuatBaoCao/ExportWord",
    method: "post",
    data,
  });
}

export function LoaiBaoCao(postdata) {
  const data = { ...postdata };
  return http({
    url: "XuatBaoCao/get-file-name",
    method: "get",
    data,
  });
}
